var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSoftSkillsViewerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 74.5,
    height: 74.5,
    fill: "#FAF8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 74.5,
    height: 74.5,
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3672 31.0118V37.8353L45.3981 34.3195V27.4961L38.3672 31.0118Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3359 43.3164V52.4995L36.6091 49.4686V40.6797L31.3359 43.3164Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6016 27.4961V34.3196L36.6324 37.8351V31.0117L29.6016 27.4961Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5029 35.7422L23.4375 38.275L30.4684 41.7906L35.5338 39.2577L28.5029 35.7422Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3672 40.6797V49.4686L43.6403 52.4995V43.3164L38.3672 40.6797Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5072 35.7422L39.4766 39.2579L44.542 41.7907L51.5726 38.275L46.5072 35.7422Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 39.8008V48.0464C22.5 48.3794 22.688 48.6833 22.9858 48.8326L29.5309 52.4995V43.3163L22.5 39.8008Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4688 43.3165V52.4996L52.0138 48.8328C52.3117 48.6834 52.4996 48.3796 52.4996 48.0466V39.8008L45.4688 43.3165Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8927 22.5927C37.6455 22.4691 37.3537 22.4691 37.1065 22.5927L30.4688 25.9703L37.4996 29.4859L44.5302 25.9702L37.8927 22.5927Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSoftSkillsViewerIcon);
export default __webpack_public_path__ + "static/media/noSoftSkillsViewerIcon.69b7ab891c69282a4abf9bd11e7744e7.svg";
export { ForwardRef as ReactComponent };